export default __webpack_public_path__ + "static/paymentlink1-1fdb178e3d6997b14c4991a91a7b6d7c.png";